/* eslint-disable */
import clsx from 'clsx';
import PropTypes, { object, string } from 'prop-types';
import React, { useState, useContext, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { Grid, Button, Tooltip } from '@mui/material';
import { AppContext, CalculatorsContext, DraftContext, ErrorContext } from '../../../context';

import Form from '../../../components/form/Form';

import AddButton from './AddButton';
import Component6Fields from './components/Component6Fields';

import { ReactComponent as HelpSvg } from '../../../assets/icons/help.svg';
import styles from './index.module.scss';
import CalcModal from '../../../components/CalcModal/CalcModal';
import FileUploader from '../../../components/fileUploader/FileUploader';
import { updateCalcAnswer } from '../../../api/rest/list';

import QuestionSharingWrapper from '../../../components/questionSharingWrapper/QuestionSharingWrapper';
import { CALC_MODELS } from '../../../constants';
import useDebounce from '../../../utils/useDebounce';

const Carbon = ({ setDescriptionItems, setChartPartData }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { idx } = useParams();

  const { setErrorAlert } = useContext(ErrorContext);
  const { draftId, draft } = useContext(DraftContext);
  const { isProduction } = useContext(AppContext);
  const {
    config,
    carbonAnswers,
    carbonQuestions,
    chartData,
    setAnswersData,
    calcSteps,
    setDirtyAnswersMap,
  } = useContext(CalculatorsContext);

  const [isFileModalOpened, setIsFileModalOpened] = useState(false);
  const [isDeleteModalOpened, setIsDeleteModalOpened] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);

  // const [index, setIndex] = useState(0);
  // const [scopeIndex, setScopeIndex] = useState(null);
  // const [categoryIndex, setCategoryIndex] = useState(null);

  const currentStep = calcSteps[idx - 1] ?? {};
  const questionIndex = currentStep?.questionIndx ?? 0;
  const scopeIndex = currentStep?.scopeIndx ?? null;
  const categoryIndex = currentStep?.categoryIndx ?? null;

  const [categoryCode, setCategoryCode] = useState(null);
  const [question, setQuestion] = useState({});

  const { id, fields } = question ?? {};
  const activities = [...(carbonAnswers?.[categoryCode]?.[id] ?? [])];

  // returns items for first selections which are not alternative
  const getSingleChoise = (item = question, i = 0) => {
    const { singleFields = [] } = question;
    if (singleFields.length == i || !item[singleFields?.[i]]?.length) return {};
    const newItem = item[singleFields[i]][0];
    if (!newItem) return {};
    const nextItem = getSingleChoise(newItem, i + 1);
    return { [singleFields[i]]: newItem.id, ...nextItem };
  };

  // initialize new activity with null values by the available fields of the question
  const initNewActivity = () => ({
    ...fields.reduce((obj, item) => ({ ...obj, [item]: null }), {}),
    ...getSingleChoise(),
  });

  useEffect(() => {
    if (!config || !carbonQuestions || scopeIndex == null || categoryIndex == null) return;
    const accordion = [];
    const model = config.models.find((m) => m.model === 'carbon');
    const { name, info: content } = model.texts.en;
    accordion.push({ name, content, expanded: false });
    const scope = carbonQuestions[scopeIndex];
    accordion.push({ name: scope.name, content: scope.description, expanded: false });
    const category = carbonQuestions[scopeIndex].categories[categoryIndex];
    if (category.description)
      accordion.push({ name: category.name, content: category.description, expanded: false });
    setDescriptionItems(accordion);
  }, [config, scopeIndex, categoryIndex, carbonQuestions]);

  useEffect(() => {
    if (!carbonQuestions) return;
    const newCategory = carbonQuestions[scopeIndex].categories[categoryIndex];
    setCategoryCode(newCategory?.code || null);

    const newQuestion = newCategory.questions[questionIndex];
    setQuestion(newQuestion);
    //calculator arc
  }, [carbonQuestions, scopeIndex, categoryIndex, questionIndex]);

  useEffect(() => {
    //chartData
    if (!chartData?.length || scopeIndex == null || categoryIndex == null) return;
    const questionChartData = chartData[scopeIndex].children[categoryIndex];
    setChartPartData([questionChartData]);
  }, [chartData, scopeIndex, categoryIndex]);

  const changeCarbonAnswers = (activities) => {
    setAnswersData({
      carbon: {
        ...carbonAnswers,
        [categoryCode]: {
          ...(carbonAnswers?.[categoryCode] ?? {}),
          [id]: activities?.length ? activities : [initNewActivity()],
        },
      },
    });
  };

  // init new result activity if it is not exist
  useEffect(() => {
    if (!id || !fields || !categoryCode || !!carbonAnswers?.[categoryCode]?.[id]) return;
    changeCarbonAnswers();
  }, [carbonAnswers, question, categoryCode]);

  // get the number of filled activities
  const activityFilledCount = () => {
    if (!question || !activities) return -1;

    return activities.filter((act) => fields.reduce((res, k) => res && !!act[k], true)).length;
  };

  const debounce = useDebounce((data) => {
    setDirtyAnswersMap(data); // Передаём валидное значение
  }, 1000);

  // save data to the draft with filtering empty fields
  const onSaveAnswer = async () => {
    debounce({ [CALC_MODELS.CARBON]: true });
  };

  // get the list of items by the field
  const getItemsList = (activity, field, currentQuestion) => {
    if (!currentQuestion) return [];
    const { singleFields = [], exceptFields = {}, fields: currentFields } = currentQuestion ?? {};

    if (!currentFields || !currentFields.length) return [];
    // get the deep of the tree to the current field
    const sliced = currentFields.slice(0, currentFields.indexOf(field) + 1);
    // get the list of items by the field

    let parent = currentQuestion;
    for (let i = 0; i < sliced.length; i++) {
      const fieldKey = sliced[i];
      if (!parent || !parent[fieldKey]) return [];

      if (fieldKey === field) {
        return parent[fieldKey];
      }
      const selectedId = activity[fieldKey];
      parent = parent[fieldKey].find((el) => el.id === selectedId);
    }
    return [];
  };

  // add new activity
  const addActivity = () => {
    const newActivities = [...activities, { ...initNewActivity() }];
    changeCarbonAnswers(newActivities);

    setTimeout(() => {
      const activitiesElements = document.getElementsByClassName('activity');
      activitiesElements[activitiesElements.length - 1].scrollIntoView({
        behavior: 'smooth',
      });
    });
  };

  function getFieldsToValidate(fields, exceptFields, activity) {
    const excluded = new Set();

    // Проверяем каждый ключ в except_fields
    for (const [exceptValue, excludedFields] of Object.entries(exceptFields)) {
      // Если значение из activity совпадает с ключом в except_fields
      if (Object.values(activity).includes(exceptValue)) {
        // Добавляем поля, которые нужно исключить
        for (const field of excludedFields) {
          excluded.add(field);
        }
      }
    }

    // Фильтруем список полей, исключая те, что попали в excluded
    return fields.filter((field) => !excluded.has(field));
  }

  // change activity data
  const changeActivity = (actIndex, field, value, label, factorId) => {
    // singleFields - fields that have only one value
    // exceptFields - fields that have alternative tree's deep
    const { singleFields = [], exceptFields = {} } = question;
    // key-value pairs {id: field} of the fields that should be disabled
    const newActivities = [...activities];
    const activity = newActivities[actIndex];
    // meta — container for the names of selected elements, to be displayed in the "All questions" modal window
    const meta = { ...activity.meta, [field]: label };

    // the fields of the current activity are divided into two parts by the current field
    const lowLevelFields = fields.includes(field) ? fields.slice(fields.indexOf(field)) : [];
    // const upLevelFields = fields.includes(field) ? fields.slice(0, fields.indexOf(field)) : fields;
    // const lowLevelFields = fields;

    if (field != 'data') {
      lowLevelFields.push('factorId');
    }

    // the data of the current activity is cleared from the current field to the end
    const clearActivity = [...lowLevelFields].reduce(
      (obj, item) => ({ ...obj, [item]: null, filled: false }),
      { ...activity }
    );
    const newActivity = { ...clearActivity, [field]: value };

    //fill the single choice fields with the first value
    fields.forEach((f) => {
      const items = getItemsList(newActivity, f, question);
      if (items && items.length == 1) {
        const firstItem = items[0];
        newActivity[f] = firstItem.id ?? firstItem.value ?? null;
        meta[f] = firstItem.name ?? firstItem.label ?? '';
        if (firstItem.factorId) {
          newActivity.factorId = firstItem.factorId;
        }
      }
    });

    // add the data field to the list of fields that should be filled
    const fieldsForValid = [
      'data',
      'factorId',
      ...getFieldsToValidate(fields, exceptFields, newActivity),
    ];

    if (factorId) {
      newActivity.factorId = factorId;
    }

    // check if the data is filled
    const isDataFilled = fieldsForValid.reduce((res, f) => res && !!newActivity[f], true);

    // get the factor_id of the current activity by the last field that should be filled
    newActivities[actIndex] = {
      ...newActivity,
      filled: isDataFilled,
      meta,
    };
    changeCarbonAnswers(newActivities);
    if (isDataFilled) onSaveAnswer();
  };

  const removeActivity = () => {
    const newActivities = activities.filter((el, indx) => indx !== deleteIndex);
    changeCarbonAnswers(newActivities);
  };

  // check if the new activity is allowed for disable the button "Add Activity"
  const isNewActivityAllowed = () => {
    if (!question || !activities.length) return false;
    return activities[activities.length - 1]?.filled;
  };

  const closeFileModal = () => {
    setIsFileModalOpened(false);
  };

  const openDeleteModal = (indx) => {
    setDeleteIndex(indx);
    setIsDeleteModalOpened(true);
  };

  const closeDeleteModal = () => {
    setDeleteIndex(null);
    setIsDeleteModalOpened(false);
  };

  const getText = (texts, type) => {
    if (!texts?.length || !type) return '';
    return texts.find((el) => el.code === type)?.text || '';
  };

  const textInfo = getText(question?.texts, 'carbon_question_info');
  return (
    <>
      <CalcModal
        opened={isDeleteModalOpened}
        closeModalFunc={closeDeleteModal}
        headerContent="Delete component"
        okBtnText="Delete"
        okFunc={removeActivity}
        needAgreement={false}
        backBtnText="Cancel"
      >
        Do you really want to delete activity №{deleteIndex + 1}?
      </CalcModal>
      <CalcModal
        opened={isFileModalOpened}
        closeModalFunc={closeFileModal}
        headerContent="Upload your confirmation docs"
        okBtnText="Ok"
        needAgreement={false}
        backBtnText="Back"
        backFunc={closeFileModal}
      >
        {question?.id && <FileUploader questionCode={question.id} model="carbon" />}
      </CalcModal>
      <Grid
        item
        container
        wrap="nowrap"
        direction="column"
        alignItems="center"
        justifyContent="space-between"
        className={styles.formContainer}
      >
        {question?.id && (
          <div>
            <Form
              headerContent={
                <>
                  <div className={styles.headerContainer}>
                    <div className={styles.companyHeaderContainer}>{question?.name}</div>
                    {!isProduction && (
                      <QuestionSharingWrapper
                        categoryCode={categoryCode}
                        questionId={id}
                        model={'carbon'}
                      />
                    )}
                  </div>
                </>
              }
            >
              {textInfo && (
                <div className={styles.subtitle}>
                  <p className={styles.subtitleText}>{textInfo}</p>
                </div>
              )}
              {activities &&
                activities.map((activity, indx) => (
                  <Component6Fields
                    key={indx}
                    question={question}
                    activity={activity}
                    index={indx}
                    onChange={changeActivity}
                    onRemove={openDeleteModal}
                    getItemsList={getItemsList}
                    isLast={indx === activities.length - 1}
                    getText={getText}
                  />
                ))}
              <div className={styles.docButtonCont}>
                {question?.id && <FileUploader questionCode={question.id} model="carbon" />}
                <AddButton
                  className={styles.addButton}
                  text="Add Activity"
                  onClick={addActivity}
                  isDisabled={!isNewActivityAllowed()}
                />
              </div>
            </Form>
          </div>
        )}
      </Grid>
    </>
  );
};

Carbon.propTypes = {
  // scope: PropTypes.string,
};

Carbon.defaultProps = {};

export default Carbon;
